/**
 * Function that compares cache and network data objects, prioritizes newest object.
 * Object with higher version number takes precedence, then object with CompletedFirstRun == true takes precedence.
 */
export function filterPriorityData(data1, data2) {
    // check for null data
    if (!data1 && !data2) {
        return null;
    }
    else if (!data1) {
        return data2;
    }
    else if (!data2) {
        return data1;
    }
    // prioritize higher version
    if (data1.Version > data2.Version) {
        return data1;
    }
    else if (data2.Version > data1.Version) {
        return data2;
    }
    // check if complete
    if (data1.CompletedFirstRun) {
        return data1;
    }
    else if (data2.CompletedFirstRun) {
        return data2;
    }
    // not complete, same version
    return data1;
}
//# sourceMappingURL=filterPriorityData.js.map